var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import * as auditPriceActions from 'action/auditPrice';
import * as reportActions from 'action/report';
import CommonReport from 'component/newCommonReport/newCommonReport';
import columns from './columns';
import { formatColumnsByType } from 'utils/formatColumnsByType';
import AuditPriceGraph from './AuditPriceGraph';
import { PriceAuditType } from 'utils/Enums';
var signalController;
var AuditPrice = function (_a) {
    var auth = _a.auth, translate = _a.translate, fetchReports = _a.fetchReports, fetchFluxGraphData = _a.fetchFluxGraphData, fetchFluxReport = _a.fetchFluxReport, fetchFlux = _a.fetchFlux;
    var _b = useState({}), formData = _b[0], setFormData = _b[1];
    var tableColumns = useState(columns)[0];
    var _c = useState(PriceAuditType.ALL_PRICES), statusPriceEnum = _c[0], setStatusPriceEnum = _c[1];
    var _d = useState(40), marginGraph = _d[0], setMarginGraph = _d[1];
    var _e = useState([]), graphData = _e[0], setGraphData = _e[1];
    var _f = useState(false), firstFetch = _f[0], setFirstFetch = _f[1];
    var _g = useState(false), inGraph = _g[0], setInGraph = _g[1];
    var _h = useState([]), branchids = _h[0], setBranchids = _h[1];
    var _j = useState([]), sectionIds = _j[0], setSectionIds = _j[1];
    var _k = useState(4), auditPriceCode = _k[0], setAuditPriceCode = _k[1];
    useEffect(function () {
        if (formData.priceAuditTypeCode) {
            var status_1 = convertNumberToStatusPrice(formData.priceAuditTypeCode);
            setStatusPriceEnum(status_1);
        }
    }, [formData.priceAuditTypeCode]);
    var fields = [
        {
            type: 'branchs',
            name: 'branchIdList',
            label: translate('irc.store'),
            help_text: translate('field.selectMultiStores'),
            error_text: translate('field_must_be_filled'),
            required: true,
            onChangeValue: function (e) {
                extractBranchs(e);
                setFormData(__assign(__assign({}, formData), { listRegionsAndBranchs: e.target.value }));
            },
        },
        {
            type: 'sections',
            name: 'sectionIdList',
            label: translate('irc.section'),
            help_text: translate('field.selectMultiSections'),
            error_text: translate('field_must_be_filled'),
            required: true,
            onChangeValue: function (e) {
                extractSections(e);
                setFormData(__assign(__assign({}, formData), { sectionInputContent: e }));
            },
        },
        {
            type: 'date_range',
            name: 'dtRange',
            label: translate('field.period.hint'),
            help_text: translate('kardex.field.dtRef.placeholder'),
            error_text: translate('field_must_be_filled'),
            required: true,
        },
        {
            type: 'radio_group',
            name: 'priceAuditTypeCode',
            title: translate("price.audit.statusPrice"),
            onChangeRadio: function (e) {
                setAuditPriceCode(e);
            },
            required: true,
            initial: 4,
            options: [
                { value: 1, label: translate('audit.price.only.correct.price') },
                { value: 2, label: translate('audit.price.only.wrong.price') },
                { value: 3, label: translate('audit.price.only.without.price') },
                { value: 4, label: translate('audit.price.only.all.price') },
            ],
        },
    ];
    function onExport() {
        var values = {
            tpReport: 36,
        };
        signalController = new AbortController();
        fetchFluxReport(auth.user.dsToken, values, formData, translate, signalController);
    }
    function onExportGraph(callback) {
        callback();
    }
    var onExportStore = function () {
        var values = {
            tpReport: 38
        };
        signalController = new AbortController();
        fetchFluxReport(auth.user.dsToken, values, formData, translate, signalController);
    };
    var onExportSection = function () {
        var values = {
            tpReport: 39
        };
        signalController = new AbortController();
        fetchFluxReport(auth.user.dsToken, values, formData, translate, signalController);
    };
    function onSubmit(submitData, setResponseInTable) {
        return __awaiter(this, void 0, void 0, function () {
            var formattedValues;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formattedValues = __assign(__assign(__assign({}, formData), submitData), { priceAuditTypeCode: auditPriceCode, branchIdList: branchids, sectionIdList: sectionIds, dtEnd: submitData.dtRange ? submitData.dtRange[1] : '', dtStart: submitData.dtRange ? submitData.dtRange[0] : '', hasPagination: true, size: submitData.limit });
                        delete formattedValues.dtRange;
                        setFormData(formattedValues);
                        signalController = new AbortController();
                        return [4 /*yield*/, fetchFlux(auth.user.dsToken, formattedValues, function (response, count, graphData) {
                                var valuesFormattedByTypes = formatColumnsByType(columns, response, translate);
                                setResponseInTable({ total: count, data: valuesFormattedByTypes });
                            }, signalController)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var fetchGraphData = function (submitData) { return __awaiter(void 0, void 0, void 0, function () {
        var formattedValues;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    formattedValues = __assign(__assign(__assign({}, formData), submitData), { priceAuditTypeCode: auditPriceCode, branchIdList: branchids, sectionIdList: sectionIds, dtEnd: submitData.dtRange ? submitData.dtRange[1] : '', dtStart: submitData.dtRange ? submitData.dtRange[0] : '', hasPagination: true, size: submitData.limit });
                    delete formattedValues.dtRange;
                    setFormData(formattedValues);
                    signalController = new AbortController();
                    return [4 /*yield*/, fetchFluxGraphData(auth.user.dsToken, formattedValues, function (graphData) {
                            setGraphData(graphData);
                        }, signalController)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (inGraph && !firstFetch) {
            setFirstFetch(true);
        }
        if (!inGraph && !firstFetch) {
            setFirstFetch(true);
        }
    }, [inGraph]);
    var convertNumberToStatusPrice = function (status) {
        switch (status) {
            case 1:
                setMarginGraph(120);
                return PriceAuditType.CORRECT_PRICE;
            case 2:
                setMarginGraph(120);
                return PriceAuditType.WRONG_PRICE;
            case 3:
                setMarginGraph(50);
                return PriceAuditType.WITHOUT_PRICE;
            default:
                setMarginGraph(40);
                return PriceAuditType.ALL_PRICES;
        }
    };
    var extractSections = function (e) {
        setSectionIds(Object.values(e).map(function (sec) { return sec.value; }));
    };
    var extractBranchs = function (e) {
        var branchs = [];
        for (var _i = 0, _a = e.target.value; _i < _a.length; _i++) {
            var b = _a[_i];
            if (b.idBranches) {
                branchs.push.apply(branchs, b.idBranches);
            }
            else {
                branchs.push(b.value);
            }
        }
        branchs = branchs.filter(function (b, p) { return branchs.indexOf(b) === p; });
        setBranchids(branchs);
    };
    var renderGraph = function () { return _jsx(AuditPriceGraph, { onExportSection: onExportSection, onExportStore: onExportStore, graphData: graphData, marginLeft: marginGraph, statusPrice: statusPriceEnum, translate: translate }); };
    return (_jsx(CommonReport, { fetchGraphData: fetchGraphData, isFlux: true, graphComponent: renderGraph, title: translate('priceAudit.report.title'), onExport: onExport, onExportGraph: onExportGraph, onSubmit: onSubmit, firstFetch: firstFetch, columns: tableColumns, fields: fields, user: auth.user, limit: 10, translate: translate, emptyReportMsg: 'no.data.found', order: true, defaultOrder: 'beepedAt' }));
};
var mapStateToProps = function (_a) {
    var auditPriceReducer = _a.auditPriceReducer, paginateReducer = _a.paginateReducer;
    return ({
        auditPriceReportList: auditPriceReducer.list,
        pages: paginateReducer.pages,
        count: paginateReducer.count,
        current: paginateReducer.current,
    });
};
function mapDispatchToProps(dispatch) {
    return bindActionCreators(__assign(__assign({}, auditPriceActions), reportActions), dispatch);
}
var AuditPriceTranslated = translate(null, {
    wait: true,
    translateFuncName: 'translate',
})(AuditPrice);
export default connect(mapStateToProps, mapDispatchToProps)(AuditPriceTranslated);
